import { Navigate } from 'react-router-dom';
import { PageLoader } from '@/components/ui';
import { useProviderSegment } from '@/hooks/useProviderSegment';

export function ProviderModuleRoute({ anyOf, children }: { anyOf: string[]; children: React.ReactNode }) {
  const { modules, isLoading } = useProviderSegment();
  if (isLoading) return <PageLoader />;
  if (!anyOf.some((moduleKey) => modules.includes(moduleKey))) {
    return <Navigate to="/business" replace />;
  }
  return <>{children}</>;
}
